import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { NeonButton } from './NeonButton';
import { ShieldCheckIcon, ArrowRightIcon, GiftIcon, CheckCircleIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://www.tumomentovital.com/cart/47625937879232:1';
export function GuaranteeSection() {
  return <SectionWrapper data-id="element-276">
      <div className="max-w-3xl mx-auto" data-id="element-277">
        <div className="bg-cyber-dark border border-gray-700 rounded-2xl p-6 md:p-8 relative overflow-hidden" data-id="element-278">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-1 bg-cyber-neon shadow-neon opacity-60" data-id="element-279"></div>

          <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-280">
            <div className="shrink-0" data-id="element-281">
              <div className="w-20 h-20 rounded-full bg-cyber-black border-2 border-cyber-neon flex items-center justify-center shadow-neon relative" data-id="element-282">
                <ShieldCheckIcon className="w-10 h-10 text-cyber-neon" data-id="element-283" />
                <div className="absolute inset-[-4px] border border-dashed border-cyber-neon/50 rounded-full animate-[spin_10s_linear_infinite]" data-id="element-284"></div>
              </div>
            </div>

            <div className="text-center md:text-left flex-1" data-id="element-285">
              <h3 className="text-xl text-white font-mono font-bold mb-3" data-id="element-286">
                Garantía de "Cero Riesgo" de 7 Días
              </h3>
              <p className="text-gray-300 text-sm leading-relaxed mb-4" data-id="element-287">
                Si aplicas el protocolo por una semana y no sientes que tu
                confianza ha subido al menos un 50%, envíanos un email y te
                devolvemos el 100% de tu dinero.{' '}
                <strong className="text-white" data-id="element-288">
                  Sin preguntas, sin resentimientos.
                </strong>{' '}
                El riesgo está todo de mi lado.
              </p>
              <NeonButton href={CHECKOUT_URL} size="md" data-id="element-289">
                Compra sin riesgo → $9.99 <ArrowRightIcon className="w-4 h-4" data-id="element-290" />
              </NeonButton>
              <span className="flex items-center gap-1.5 text-[11px] font-mono bg-cyber-neon/5 border border-cyber-neon/30 rounded-full px-3 py-1.5 mt-2 shadow-[0_0_8px_rgba(57,255,20,0.1)]" data-id="element-291">
                <GiftIcon className="w-3 h-3 text-cyber-neon animate-pulse" data-id="element-292" />
                <span className="text-gray-300" data-id="element-293">
                  + 2 Bonos <strong className="text-cyber-neon" data-id="element-294">GRATIS</strong>{' '}
                  incluidos <span className="text-gray-500" data-id="element-295">(valor $47)</span>
                </span>
              </span>
              <div className="bg-cyber-dark/60 border border-cyber-neon/15 rounded-lg p-2.5 space-y-1.5 mt-1" data-id="element-296">
                <div className="flex items-start gap-2" data-id="element-297">
                  <CheckCircleIcon className="w-3.5 h-3.5 text-cyber-neon shrink-0 mt-0.5" data-id="element-298" />
                  <p className="text-[10px] font-mono text-gray-400 leading-tight" data-id="element-299">
                    <span className="text-gray-300 font-bold" data-id="element-300">Bonus 1:</span>{' '}
                    Scripts de Supervivencia en Citas — qué decir para que nunca
                    haya silencios incómodos.
                    <span className="ml-1 text-gray-500 line-through" data-id="element-301">$25</span>
                    <span className="ml-1 text-cyber-neon font-bold" data-id="element-302">
                      GRATIS
                    </span>
                  </p>
                </div>
                <div className="flex items-start gap-2" data-id="element-303">
                  <CheckCircleIcon className="w-3.5 h-3.5 text-cyber-neon shrink-0 mt-0.5" data-id="element-304" />
                  <p className="text-[10px] font-mono text-gray-400 leading-tight" data-id="element-305">
                    <span className="text-gray-300 font-bold" data-id="element-306">Bonus 2:</span>{' '}
                    Templates de Texto Irresistibles — para que nunca más te
                    dejen en "visto" en WhatsApp.
                    <span className="ml-1 text-gray-500 line-through" data-id="element-307">$22</span>
                    <span className="ml-1 text-cyber-neon font-bold" data-id="element-308">
                      GRATIS
                    </span>
                  </p>
                </div>
                <div className="border-t border-cyber-neon/20 pt-1.5 mt-1" data-id="element-309">
                  <p className="text-[11px] font-mono text-cyber-neon font-bold text-center" data-id="element-310">
                    Te ahorras $47 USD en bonos de regalo
                  </p>
                </div>
              </div>
              <button onClick={() => document.getElementById('bonos')?.scrollIntoView({
              behavior: 'smooth'
            })} className="text-[11px] text-cyber-neon font-mono underline underline-offset-2 hover:text-white transition-colors mt-1" data-id="element-311">
                Leer más
              </button>
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}